angular.module("hiddenCodeManagementModule", [
    "hiddenCodeManagementServiceModule",
    "hClassifyManagement",
    "hiddenCodeManagementRouterModule",
    "hEventManagementModule",
    "hStopEventModule"
]);